import styled from "styled-components";
import { colors, text, values } from "~/assets/js/theme/constants";

const getTextColor = (props) => {
    switch (props.appearance) {
        case "primary":
            return colors.WHITE;
        case "default":
            return colors.WHITE;
    }
};

const getBackgroundColor = (props) => {
    switch (props.appearance) {
        case "primary":
            return colors.BRAND.PRIMARY[1000];
        case "default":
            return colors.LAYOUT.GRAY[1000];
    }
};

const getBackgroundHoverColor = (props) => {
    switch (props.appearance) {
        case "primary":
            return colors.BRAND.PRIMARY[800];
        // case "ghost":
        //     return colors.WHITE;
        case "default":
            return colors.LAYOUT.GRAY[800];
    }
};

export const StyledButton = styled.div`
    height: 48px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-radius: 100px;
    background: ${(props) => getBackgroundColor(props)};
    transition: ${values.DEFAULT_TRANSITION_DURATION};
    margin-bottom: 6px;
    min-width: 46px;
    &:last-of-type {
        margin-bottom: 0;
    }

    &:hover,
    &:active,
    &:focus {
        background: ${(props) => getBackgroundHoverColor(props)};
        ${(props) => (props.disabled ? "" : `filter: brightness(110%);`)}
    }
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
    ${(props) => (props.disabled ? "filter: grayscale(100%);" : "")}
`;

export const Content = styled.div`
    font-size: 18px;
    line-height: 21px;
    font-family: ${text.BOLD.FONT};
    font-weight: ${text.BOLD.WEIGHT};
    color: ${(props) => getTextColor(props)};
`;

export const Icon = styled.div`
    margin: ${(props) => (props.iconOnly ? "0 -3px 0 -3px" : "0 8px 0 0")};
    transform: scale(${(props) => props.iconScale});
`;

export const LoadingContainer = styled.div`
    margin-right: 16px;
    filter: brightness(1000%);
`;
